import { iResponse } from "../models/interfaceResponse";

export const chatbotDynamicForm = async (
  schema: FormSchemaFrm, 
  data: Record<string, any>
): Promise<any> => {
  try {
    console.log("Enviando solicitud al API con el siguiente esquema y datos:", schema, data);
    let body: BodyInit | null = null;
    let headers: HeadersInit = {};
    // agregar max 20, formulario 
    schema.headers.forEach(({ key, value }) => {
      if (key && value) {
        headers[key] = value;
      }
    });
    switch (schema.enctype) {
      case "application/x-www-form-urlencoded":
        const urlEncodedData = new URLSearchParams();
        Object.entries(data).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            urlEncodedData.append(key, String(value));
          }
        });
        body = urlEncodedData.toString();
        headers["Content-Type"] = "application/x-www-form-urlencoded"; 
        break;

      case "multipart/form-data":
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            formData.append(key, value);
          }
        });
        body = formData; 
        break;

      case "application/json":
        body = JSON.stringify(data);
        headers["Content-Type"] = "application/json";
        break;

      case "text/plain":
        body = typeof data === "string" ? data : JSON.stringify(data);
        headers["Content-Type"] = "text/plain";
        break;

      default:
        throw new Error(`Tipo de contenido no soportado: ${schema.enctype}`);
    }

    // Si el método es GET, agregamos los parámetros a la URL
    let url = schema.action;
    if (schema.method === "GET" && Object.keys(data).length > 0) {
      const queryString = new URLSearchParams(data as Record<string, string>).toString();
      url += `?${queryString}`;
    }

    const response = await fetch(url, {
      method: schema.method,
      headers: schema.enctype !== "multipart/form-data" ? headers : undefined, // No establecer headers en multipart
      body: schema.method !== "GET" ? body : null,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error ${response.status}: ${errorText}`);
    }

    // Intentar parsear la respuesta
    const contentType = response.headers.get("Content-Type") || "";
    if (contentType.includes("application/json")) {
      return await response.json();
    } else {
      return await response.text();
    }

  } catch (error) {
    console.error("❌ Error en sendApiRequest:", error);
    throw error;
  }
};
